<div class="thank-you-container">
 <div class="header">
    <img src="assets/logo/logo-full-green.png" alt="Check Plus Logo" class="logo" />

  </div>

  <div class="content">

      <img src="assets/sing-up/thankyou.svg" alt="Thank You" class="thank-you-icon" />


    <h1 class="title">Thank you for creating an account with us.</h1>
    <p class="message">we sent you an email, Please complete your profile</p>

    <button
      gbui-button
      class="login-button"
      (click)="onLoginClick()"
      context="primary"
    >
      Back to Login
    </button>
  </div>
</div>
